<template>
  <footer class="footer">
    <div class="footerLink">
      <img src="/img/lp-create/create-logo.svg" alt="LegalScript書類作成" width="227" height="39" />
      <div class="links">
        <div class="line">
          <nuxt-link to="/trade-application" class="">特定商取引法に基づく表記</nuxt-link>
          <nuxt-link target="_blank" to="/terms-application" class="">利用規約</nuxt-link>
          <nuxt-link target="_blank" to="/privacy-application" class="">プライバシーポリシー</nuxt-link>
        </div>
        <div class="line">
          <nuxt-link to="/contact-application" class="">お問い合わせ</nuxt-link>
          <a href="https://sample-text.co.jp/" target="_blank" class="">運営会社<i class="las la-external-link-alt"></i></a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'f-footer-lp-create'
}
</script>
